interface CtaBlockProps {
  eyebrow?: string;
  headline: string;
  subheadline: string;
  primaryLabel: string;
  primaryHref: string;
  secondaryLabel?: string;
  secondaryHref?: string;
  variant?: 'solid' | 'compact';
}

export default function CtaBlock({
  eyebrow,
  headline,
  subheadline,
  primaryLabel,
  primaryHref,
  secondaryLabel,
  secondaryHref,
  variant = 'solid',
}: CtaBlockProps) {
  if (variant === 'compact') {
    return (
      <div className="bg-gradient-to-br from-navy-900 via-navy-800 to-navy-900 rounded-xl p-5 md:p-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4 shadow-lg">
        <div>
          {eyebrow && (
            <p className="text-orange-400 text-xs font-bold uppercase tracking-wide mb-1">
              {eyebrow}
            </p>
          )}
          <p className="text-white text-lg md:text-xl font-display font-bold">{headline}</p>
          <p className="text-white/90 text-sm">{subheadline}</p>
        </div>
        <a
          href={primaryHref}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-primary whitespace-nowrap text-sm md:text-base"
        >
          {primaryLabel} <i className="ri-arrow-right-line ml-1"></i>
        </a>
      </div>
    );
  }

  return (
    <section className="py-16 bg-gradient-to-br from-navy-900 via-navy-800 to-navy-900">
      <div className="max-w-4xl mx-auto px-6 text-center text-white">
        {eyebrow && (
          <p className="text-orange-400 text-sm font-bold uppercase tracking-wide mb-3">{eyebrow}</p>
        )}
        <h2 className="text-3xl md:text-5xl font-display font-bold mb-4">{headline}</h2>
        <p className="text-white/90 text-lg md:text-xl mb-8 max-w-2xl mx-auto">{subheadline}</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href={primaryHref}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary text-lg"
          >
            {primaryLabel} <i className="ri-arrow-right-line ml-2"></i>
          </a>
          {secondaryLabel && secondaryHref && (
            <a
              href={secondaryHref}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white/10 backdrop-blur-sm border-2 border-teal-400 text-white px-8 py-4 rounded-lg font-bold hover:bg-white/20 transition-all text-lg"
            >
              {secondaryLabel}
            </a>
          )}
        </div>
      </div>
    </section>
  );
}
